import { GetAllVendorOnboardingRequest } from "API/VendorOnboarding/api";
import { useState } from "react";
import { useEffect } from "react";
import BackdropLoader from "../General/Loader";
import SnackBar from "../General/SnackBar";
import SubCard from "ui-component/cards/SubCard";
import Pagination from '@mui/material/Pagination';
import VendorViewModal from "./Components/ViewRequestDialog";

const { Grid, Stack, Typography } = require("@mui/material")


const PendingForm = (props) => {
  const [Data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [AlertMessage, setAlertMessage] = useState(null)
  const [AlertType, setAlertType] = useState("success")
  const [OpenAlert, setOpenAlert] = useState(false)
  const [OpenViewModal, setOpenViewModal] = useState(false)
  const [SelectedRequest, setSelectedRequest] = useState(null)
  const [Page, setPage] = useState(1)

  const rowsperpage = 10

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  function formatTime(dateString) {
    const date = new Date(dateString);
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    const formattedHours = hours.toString().padStart(2, '0');
    const formattedTime = `${formattedHours}:${minutes}:${seconds} ${ampm}`;
    return `${formattedTime}`;
  }


  const handleViewModal = (item) => {
    setSelectedRequest(item)
    setOpenViewModal(true)

  }


  const handleCloseViewModal = () => {
    setOpenViewModal(false)
  }

  const handleAlertOpen = (message, type) => {
    setAlertMessage(message)
    setAlertType(type)
    setOpenAlert(true)
  }

  const handleAlertClose = () => {
    setOpenAlert(false)

  }

  const HandlePageChange = (event, value) => {
    console.log(value);

    setPage(value);
    GetAllVendorOnboardingRequest(setLoading, setData, handleAlertOpen, props.type, value, rowsperpage)

  };

  useEffect(() => {
    GetAllVendorOnboardingRequest(setLoading, setData, handleAlertOpen, props.type, Page, rowsperpage)
    props.callback({setData:setData,type:props.type})
  }, [props.type])

  console.log("data", Data);



  return (
    <Grid container>
      <BackdropLoader open={loading} />
      <SnackBar message={AlertMessage} type={AlertType} open={OpenAlert} handleClose={handleAlertClose} />
      <VendorViewModal open={OpenViewModal} data={SelectedRequest} handleClose={handleCloseViewModal} type={props.type} />
      <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
        <Stack height="100%" overflow="scroll" sx={{ scrollbarWidth: 'none' }} gap={1}>
          {
            Data && Data.vendors && Array.isArray(Data.vendors) ?
              Data.vendors.map((item, index) => (

                <SubCard title={`Onboarding for ${item.vendor_name}  ${item.vendor_code || ""}`} key={index} sx={{ cursor: 'pointer' }} onClick={() => handleViewModal(item)}>
                  <table>
                    <tr>
                      <th style={{ textAlign: "left" }}>Date</th>
                      <td>:</td>
                      <td>{formatDate(item.vendor_added_by.added_at)}</td>
                    </tr>
                    <tr>
                      <th style={{ textAlign: "left" }}>Time</th>
                      <td>:</td>
                      <td>{formatTime(item.vendor_added_by.added_at)}</td>
                    </tr>
                    <tr>
                      <th style={{ textAlign: 'left' }}>Created By</th>
                      <td>:</td>
                      <td>{item.vendor_added_by.user_name}</td>
                    </tr>
                    {
                      item.vendor_status_updated_by ?
                        <tr>
                          <th style={{ textAlign: 'left' }}>Updated By</th>
                          <td>:</td>
                          <td>{item.vendor_status_updated_by.user_name}</td>
                        </tr>
                        :
                        null

                    }

                  </table>
                </SubCard>

              ))
              :
              <Stack width="100%" justifyContent="center" alignItems="center">
                <Typography variant="h5">No Data</Typography>
              </Stack>
          }
          <Pagination page={Page} count={Data ? Data.total_pages : 0} variant="outlined" shape="rounded" onChange={HandlePageChange} />
        </Stack>
      </Grid>
    </Grid>
  )
}


export default PendingForm;